var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5007 36.6673C29.7053 36.6673 37.1673 29.2053 37.1673 20.0007C37.1673 10.7959 29.7053 3.33398 20.5007 3.33398C11.2959 3.33398 3.83398 10.7959 3.83398 20.0007C3.83398 29.2053 11.2959 36.6673 20.5007 36.6673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.05 28.3337C20.75 28.4337 20.2333 28.4337 19.9333 28.3337C17.3333 27.4503 11.5 23.7337 11.5 17.4337C11.5 14.6504 13.7333 12.4004 16.5 12.4004C18.1333 12.4004 19.5833 13.1837 20.5 14.417C21.4 13.2004 22.8666 12.4004 24.5 12.4004C27.2667 12.4004 29.5 14.6504 29.5 17.4337C29.5 23.7337 23.6667 27.4503 21.05 28.3337Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartCircle);
export default __webpack_public_path__ + "static/media/heart-circle.136adec9df5a42a8cedefcd76a9cd596.svg";
export { ForwardRef as ReactComponent };